import { render, staticRenderFns } from "./TelemedicineHistoryTable.vue?vue&type=template&id=6916002c&"
import script from "./TelemedicineHistoryTable.vue?vue&type=script&lang=js&"
export * from "./TelemedicineHistoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports